"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = __importDefault(require("./app"));
const dodns_1 = __importDefault(require("./dodns"));
const records_1 = __importDefault(require("./records"));
const truncated_record_1 = __importDefault(require("./truncated_record"));
const whois_1 = __importDefault(require("./whois"));
const propagation_modal_1 = __importDefault(require("./propagation_modal"));
const record_selection_modal_1 = __importDefault(require("./record_selection_modal"));
const dns_diff_1 = __importDefault(require("./dns_diff"));
const clipboard_modal_1 = __importDefault(require("./clipboard_modal"));
const dmarc_explainer_1 = __importDefault(require("./dmarc_explainer"));
exports.default = {
    app: app_1.default, dodns: dodns_1.default, records: records_1.default, truncatedRecord: truncated_record_1.default,
    whois: whois_1.default, propagationModal: propagation_modal_1.default, recordSelectionModal: record_selection_modal_1.default,
    dnsDiff: dns_diff_1.default, clipboardModal: clipboard_modal_1.default, dmarcExplainer: dmarc_explainer_1.default,
};
